import { type MeasureMode, measureModeColor } from '~/utils/annotationKinds';
import { svgCursorStyle } from './svgCursorStyle';

/** Four arms around an open centre, on the pixel at (12, 12). */
const CROSSHAIR_PATH = 'M12.5 2.5v7m0 6v7M2.5 12.5h7m6 0h7';

function cursorFor(mode: MeasureMode, glyph: string): string {
    const color = measureModeColor(mode);
    const svg = [
        '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">',
        `<path d="${CROSSHAIR_PATH}" stroke="#000" stroke-width="3" stroke-linecap="square"/>`,
        `<path d="${CROSSHAIR_PATH}" stroke="#fff" stroke-width="1" stroke-linecap="square"/>`,
        '<g stroke-linecap="round" stroke-linejoin="round">',
        `<path d="${glyph}" stroke="#000" stroke-width="3.5"/>`,
        `<path d="${glyph}" stroke="${color}" stroke-width="1.5"/>`,
        '</g></svg>',
    ].join('');
    return svgCursorStyle(svg, { x: 12, y: 12 }, 'crosshair');
}

/**
 * Precision crosshair for placing each shape, its glyph below-right in its
 * family's colour over a wider black outline that reads on any anatomy.
 */
export const MEASURE_CURSORS = {
    distance: cursorFor('distance', 'M20.5 25.5h9M20.5 22.5v6M29.5 22.5v6'),
    angle: cursorFor('angle', 'M29.5 29.5h-9l6-9M25.5 29.5a5 5 0 0 0-2.2-4.2'),
    profile: cursorFor('profile', 'M20.5 29c2.5 0 2.5-8 4.5-8s2 8 4.5 8'),
    circle: cursorFor('circle', 'M29.5 25a4.5 4.5 0 1 1-9 0a4.5 4.5 0 1 1 9 0'),
    rectangle: cursorFor('rectangle', 'M20.5 21.5h9v7h-9z'),
} satisfies Record<MeasureMode, string>;
